"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.FULLSCREEN_MODES = exports.QD_MODES = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _Nugget2 = _interopRequireDefault(require("../Nugget"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QD_MODES = {
  MULTPLAYER: 'game',
  SINGLE_PLAYER: 'singleplayer',
  TOURNAMENT: 'tournament',
  HIGHSCORE: 'highscore',
  LEARNING_PROGRESSION: 'learning_progression'
};
exports.QD_MODES = QD_MODES;
var FULLSCREEN_MODES = {
  AUTO: 'auto',
  FULLSCREEN: 'fullscreen',
  INLINE: 'inline'
};
exports.FULLSCREEN_MODES = FULLSCREEN_MODES;

var QdNugget = /*#__PURE__*/function (_Nugget) {
  (0, _inherits2["default"])(QdNugget, _Nugget);

  var _super = _createSuper(QdNugget);

  function QdNugget(json) {
    var _this;

    (0, _classCallCheck2["default"])(this, QdNugget);
    _this = _super.call(this, json);
    _this.showTitle = json.show_title;
    _this.categories = json.categories;
    _this.showChooser = json.show_chooser;
    _this.mode = json.mode;
    _this.fullscreenMode = json.fullscreenMode || 'auto';
    _this.disableTimer = json.disable_timer || false;
    _this.countUserPoints = json.count_userpoints || true;
    _this.affectLearnState = json.affect_learnstate || true;
    return _this;
  }

  return QdNugget;
}(_Nugget2["default"]);

QdNugget.CLASS = 'qd';
var _default = QdNugget;
exports["default"] = _default;